import axiosApiInstance from "../../app/axios";
import { PARKIT_API_BASE_URL } from "../../app/utils";
import { getJwtToken } from "../../app/common";

export const getParkitSubscriptionsByUsername = async (username, page, size, sort, sortBy, chargeStatuses) =>
  axiosApiInstance.get(
    `${PARKIT_API_BASE_URL}/parkit/v2/subscriptions?page=${page}&size=${size}&sort=${sort}&sortBy=${sortBy}&chargeStatuses=${chargeStatuses}&username=${username}`,
    { headers: { "Authorization": `Bearer ${getJwtToken()}` } }
  );

export { manualChargeParkitSubscription } from "../../api/parkitSubscriptionAPI";

export const pauseChargeSubscription = async (subscription_id, wallet_id) =>
  axiosApiInstance.post(
    `${PARKIT_API_BASE_URL}/parkit/v2/subscriptions/pause-charge`,
    {
      walletId: wallet_id,
      subscriptionId: subscription_id
    },
    { headers: { "Authorization": `Bearer ${getJwtToken()}` } }
  );

export const recreateSubscription = async (subscription) =>
  axiosApiInstance.post(
    `${PARKIT_API_BASE_URL}/parkit/v2/subscriptions/recreate`,
    subscription,
    { headers: { "Authorization": `Bearer ${getJwtToken()}` } }
);

export const updateSubscription = async (id, subscription) =>
  axiosApiInstance.post(
    `${PARKIT_API_BASE_URL}/parkit/v2/subscriptions/${id}/patch`,
    subscription,
    { headers: { "Authorization": `Bearer ${getJwtToken()}` } }
);